import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { DownloadXlsxService } from '../../../shared/services/download-xlsx.service';
import { FmLoadingPageService } from '../../../shared/services/fm-loading-page.service';
import { ReportServiceService } from '../report-service.service';

import type { OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-rcr-volume-report',
  templateUrl: './rcr-volume-report.component.html',
  styleUrls: ['./rcr-volume-report.component.scss'],
})
export class RcrVolumeReportComponent implements OnInit {
  public rcrVolumeData: any;
  year: string;
  responseMessageFlag = false;
  responseMessage: any;

  private reportService = inject(ReportServiceService);
  public fmLoadingPageService = inject(FmLoadingPageService);
  private downloadXlsxService = inject(DownloadXlsxService);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit() {
    this.year = new Date().getFullYear().toString();
    this.runReport(this.year);
  }

  public viewReport(): void {
    this.fmLoadingPageService.isLoaderRequesting.set(true);
    const rcrDownloadList = [];
    const fileName = 'rcr-volume-report';

    for (const data of this.rcrVolumeData) {
      const rcrList: Record<string, string> = {};
      rcrList.Month = data.monthString;
      rcrList['Deal Type'] = data.displayDealType;
      rcrList.Count = data.count;
      rcrList['Current Face Amount'] = data.currentFaceAmountStr;
      rcrList['Exchange Fee Dollars'] = data.exchangeFeeDollarsStr;
      rcrDownloadList.push(rcrList);
    }

    this.downloadXlsxService.generateRCRVolumeReportExcel(rcrDownloadList, fileName);

    // this.fmJsonToExcelService.exportAsXLSX(JSON.stringify(rcrDownloadList,undefined, 2), "rcr-volume-report");

    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  private handleRCRVolumeReportSuccess(data: any) {
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.responseMessageFlag = false;
    this.rcrVolumeData = data.stranXchange;
    this.responseMessage = data.responseMessage;

    if (this.responseMessage != null) {
      this.responseMessageFlag = true;
    }
    this.cdr.markForCheck();
  }
  private handleRCRVolumeReportServiceFail(_error: any) {
    this.cdr.markForCheck();
  }

  public runReport(date: any): void {
    this.fmLoadingPageService.isLoaderRequesting.set(true);
    this.reportService.rcrVolumeSummaryReport(date).subscribe({
      next: (data) => this.handleRCRVolumeReportSuccess(data),
      error: (error) => this.handleRCRVolumeReportServiceFail(error),
    });
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
